export enum EPortal {
    Immonet = 'IMN',
    Immoweb = 'IWB',
    Immowelt = 'IWT',
    LogicImmo = 'LI',
    SeLoger = 'SL',
}

export const TrackingPortal: { [key in EPortal]: string } = {
    [EPortal.Immonet]: 'INT',
    [EPortal.Immoweb]: 'IWB',
    [EPortal.Immowelt]: 'IWT',
    [EPortal.LogicImmo]: 'LICOM',
    [EPortal.SeLoger]: 'SL',
};
